define('views/pages/checkout/CheckoutStepPaymentView',['underscore', 'jquery', 'app', 'hooks',
        'views/pages/checkout/CheckoutStepView',
        'views/blocks/CheckoutAddressView',
        'views/blocks/CheckoutPaymentView',
        'WidgetCollectionView',
    'template!blocks/checkout/message-shop',
    'template!blocks/checkout/contactless-delivery',
    'template!blocks/checkout/informations-and-payment',
    'template!blocks/checkout/delivery-options',
    'template!blocks/checkout/require-authentication',
    'template!blocks/checkout/require-store',
    'template!blocks/checkout/total-price-payments',
    'views/blocks/checkout/ShopMessageCheckoutDialogView',
    'BtnSwitchView',
    ],
    function (_, $, app, hooks,
              CheckoutStepView,
              CheckoutAddressView,
              CheckoutPaymentView,
              WidgetCollectionView,
              templateMessageShop,
              templateContactlessDelivery,
              templateInformationAndPayment,
              templateDeliveryOptions,
              templateRequireAuthentication,
              templateRequireStore,
              templateTotalPricePayments,
              ShopMessageCheckoutDialogView,
              BtnSwitchView
              ) {

        var view, checkoutModel;

        return CheckoutStepView.extend({

            name:'payment',
            events: {
                'click .btn--message-shop':'clickMessageShop',
                'click .btn-auth':'requireAuthentification',
                'click .btn-store':'requireStore',
            },

            beforeInitialize: function (model) {
                view = this;
                checkoutModel = model;
                var cart = app.getCart();
                view.listenTo(app.getCustomer(),'logout login',view.render);
                view.listenTo(cart,'change:id_store', view.render);
                view.listenTo(cart,'change:total_price_ttc change:cagnotte',view.updateCartPriceTotal);
                view.listenTo(cart,'change:vae',view.updateContactLess);
                view.listenTo(checkoutModel,'change:id_payment_mode change:alt_payment_mode',view.updateCartPriceTotal);
                view.listenTo(app,'paymentModeRequirement',view.updateCartPriceTotal);
                view.listenTo(cart, 'change:order_message', view.onChangeMessage);
                setTimeout(view.requireAuthentification,10);
            },

            render:function(){
                var cart = app.getCart(),
                    isLogged = app.getCustomer().isLogged();
                if(!isLogged){
                    view.$el.html(templateRequireAuthentication());
                    return;
                }else if(!cart.getStore()){
                    view.$el.html(templateRequireStore({cart:cart}));
                    return;
                }
                var groupWidgetFinalName = 'checkout_extra_payment',
                    groupWidgetFinal = app.getWidgetGroup(groupWidgetFinalName),
                    options = {theme:'dark',checkout:checkoutModel};

                view.$el.html(templateInformationAndPayment(options));
                view.appendView(CheckoutAddressView,'.checkout-address', options);
                view.appendView(CheckoutPaymentView,'.checkout-payment', options);
                //

                if (groupWidgetFinal) {
                    var collection = new WidgetCollectionView(groupWidgetFinalName);
                    view.$('.checkout-opc__widget-final').html(collection.el);
                    view.attachView(collection);
                }

                view.updateCartPriceTotal();
                view.afterRender();

            },

            afterRender:function() {
                var view = this,
                    cart = app.getCart(),
                    idContactlessDelivery = app.c('_CONTACTLESS_DELIVERY_PRODUCT_'),
                    product = cart.getProduct(idContactlessDelivery),
                    btnSwitchEl, btnSwitch;
                if(!!idContactlessDelivery){
                    btnSwitchEl = view.$('.checkout-contacless-delivery'),
                    btnSwitch = new BtnSwitchView({value: product?'yes':'no',el:btnSwitchEl});
                    view.attachView(btnSwitch);
                    view.listenTo(btnSwitch,'change',view.onSwitchChange);
                }
            },

            updateCartPriceTotal:function(){
                this.$('.cart-total-price').text(checkoutModel.formatPriceTotal())
                this.$('.cart-total-price-payments').html(templateTotalPricePayments(checkoutModel));
            },

            requireAuthentification:function(){
                return checkoutModel.requireAuthentification();
            },

            requireStore:function(){
                return checkoutModel.requireDeliveryOptions();
            },

            onChangeMessage:function(){
                this.$('.btn--message-shop span').text(checkoutModel.getOrderMessage());
            },

            clickMessageShop:function(){
                new ShopMessageCheckoutDialogView({checkoutModel:checkoutModel});
            },

            updateContactLess:function(){
                this.$('.checkout-opc__contactless-delivery').attr('data-contactless-delivery', checkoutModel.contactlessDeliveryVisible() ? 1:0);
            },

            onSwitchChange: function(value) {
                var cart = app.getCart(),
                    idContactlessDelivery = app.c('_CONTACTLESS_DELIVERY_PRODUCT_')
                //
                if(idContactlessDelivery && cart.isVAD()){
                    switch(value){
                        case 'yes': // ajoute le produit au panier
                            cart.addProduct(idContactlessDelivery);
                            break;
                        case 'no': default: // retire le produit du panier
                            cart.deleteProduct(idContactlessDelivery);
                            break;
                    }
                }
            }

        });
    });

